import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSalesData, getCampaigns } from '../services/sales';

const SalesContext = createContext();

export const SalesProvider = ({ children }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [salesData, setSalesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentSale, setCurrentSale] = useState(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        // Carregar campanhas e dados de vendas em paralelo
        const [campaignsData, sales] = await Promise.all([
          getCampaigns(),
          getSalesData()
        ]);
        
        setCampaigns(campaignsData);
        setSalesData(sales);
        setError(null);
      } catch (err) {
        console.error('Erro ao carregar dados de vendas:', err);
        setError('Falha ao carregar dados. Tente novamente mais tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  const startNewSale = (productDetails) => {
    setCurrentSale({
      id: `draft-${Date.now()}`,
      status: 'draft',
      product: productDetails,
      customer: null,
      payment: null,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
  };

  const updateSaleDetails = (details) => {
    if (!currentSale) return;
    
    setCurrentSale({
      ...currentSale,
      ...details,
      updatedAt: new Date()
    });
  };

  const cancelCurrentSale = () => {
    setCurrentSale(null);
  };

  const value = {
    campaigns,
    salesData,
    loading,
    error,
    currentSale,
    startNewSale,
    updateSaleDetails,
    cancelCurrentSale
  };

  return <SalesContext.Provider value={value}>{children}</SalesContext.Provider>;
};

export const useSalesContext = () => {
  const context = useContext(SalesContext);
  if (!context) {
    throw new Error('useSalesContext deve ser usado dentro de um SalesProvider');
  }
  return context;
};
